/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountDetails } from '../../models/account-details';

export interface AccountControllerFindAccountDetails$Params {
  id: string;
}

export function accountControllerFindAccountDetails(http: HttpClient, rootUrl: string, params: AccountControllerFindAccountDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountDetails>> {
  const rb = new RequestBuilder(rootUrl, accountControllerFindAccountDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountDetails>;
    })
  );
}

accountControllerFindAccountDetails.PATH = '/account/details/{id}';
